module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-43.f634e726.svg";